import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';

import { Avatar, Button, Heading, P } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface ContentCardInfoProp extends SbBlokData {
  image: MediaProps[];
  link: { cached_url: string };
  title: string;
  description: string;
  buttonText?: string;
  target: '_self' | '_blank';
}

interface Blok extends PageSectionBlok {
  title: string;
  contentInfoCard: ContentCardInfoProp[];
}
interface ContentInfoCardsProps extends PageSectionProps {
  blok: Blok;
}

export const ContentInfoCards: FunctionComponent<React.PropsWithChildren<ContentInfoCardsProps>> = ({ blok }) => {
  const { title, contentInfoCard, hasBackground, hasBorder, hasPaddingBottom, hasPaddingTop } = blok;
  const cards = contentInfoCard.map(({ title: cardTitle, image, description, link, target, buttonText, _uid }) => (
    <div key={`blog-post-${_uid}`} className="sm:w-full md:w-1/3 p-4">
      <a href={link.cached_url} target={target}>
        {image.length > 0 && (
          <Avatar
            src={image[0]?.img}
            size="xl"
            alt={image[0].alt}
            loading="lazy"
            circle={false}
            wrapperClassName="w-full"
          />
        )}
        <Heading kind="3" color="text-primary" className="my-7">
          {cardTitle}
        </Heading>
        {description && <P>{description}</P>}
      </a>
      {buttonText && (
        <div className="flex mt-7">
          <Button kind="primary" href={link.cached_url} target={target}>
            {buttonText || 'Read full article'}
          </Button>
        </div>
      )}
    </div>
  ));

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
      hasBorder={hasBorder}
      blok={blok}
    >
      <PageSectionHeader className="sm:text-center">{title}</PageSectionHeader>
      <div className="flex flex-wrap justify-center">{cards}</div>
    </Section>
  );
};
